<template>
    <v-dialog v-model="objFormBeneComp.abrirModal" max-width="80%" :scrollable="$root.isTouch == false"
        :fullscreen="$root.isTouch" persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card"> <span class="white--text headline"
                    v-html="objFormBeneComp.titulo"></span></v-card-title>
            <v-card-text>
                <v-form ref="form_beneficio_complementario" :lazy-validation="true">
                    <v-container fluid grid-list-sm>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Aseguradora *" color="textbox"
                                    v-model="objFormBeneComp.idAseguradora" @change="onListarSeguros($event,true)"
                                    :items="listGeneralModal.listAseguradora" item-value="idAseguradora"
                                    item-text="aseguradora" :rules="requeridoRegla" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Seguro" color="textbox" v-model="objFormBeneComp.idSeguro"
                                    :items="listGeneralModal.listSeguro" item-value="idSeguro" item-text="seguro"
                                    :rules="requeridoRegla" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field label="Beneficio *" color="textbox"
                                    v-model="objFormBeneComp.beneficio_comp"
                                    :rules="_.concat(requeridoRegla,soloLetrasRegla(1,objFormBeneComp.beneficio_comp,300))"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-row dense>
                                    <v-col cols="2" sm="1">
                                        <v-tooltip right color="primary">
                                            <template v-slot:activator="{ on }">
                                                <v-icon class="mt-3" color="primary"
                                                    @click="abrirVentana($event,'logoWeb')" v-html="'cloud_upload'"
                                                    v-on="on" />
                                                <input type="file" style="display: none;" ref="logoWeb"
                                                    @change="obtenerFile($event,'logoWeb')"
                                                    accept="image/svg+xml,image/png" />
                                            </template>
                                            <span>Subir Icono Web</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="12" sm="11">
                                        <div class="text-center" v-show="_.size(objFormBeneComp.logoWeb)">
                                            <img :src="objFormBeneComp.logoWeb" class="image" alt="Logo Web" />
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-row dense>
                                    <v-col cols="2" sm="1">
                                        <v-tooltip right color="primary">
                                            <template v-slot:activator="{ on }">
                                                <v-icon class="mt-3" color="primary"
                                                    @click="abrirVentana($event,'logoApp')" v-html="'cloud_upload'"
                                                    v-on="on" />
                                                <input type="file" style="display: none;" ref="logoApp"
                                                    @change="obtenerFile($event,'logoApp')"
                                                    accept="image/svg+xml,image/png" />
                                            </template>
                                            <span>Subir Icono App</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col xs10 sm11>
                                        <div class="text-center" v-show="_.size(objFormBeneComp.logoApp)">
                                            <img :src="objFormBeneComp.logoApp" class="image" alt="Logo App" />
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-textarea color="textbox" label="Definición del beneficio (Breve)"
                                    v-model="objFormBeneComp.definicion_corta"
                                    :value="objFormBeneComp.definicion_corta" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-textarea color="textbox" label="Definición Técnica para el CIS"
                                    v-model="objFormBeneComp.definicion_tecnica_cis"
                                    :value="objFormBeneComp.definicion_tecnica_cis" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-autocomplete label="Tipo Cálculo Beneficio *" color="textbox"
                                    v-model="objFormBeneComp.id_tipo_calculo"
                                    :items="listGeneralModal.listTipoCalculo" item-value="id_tipo_calculo"
                                    item-text="tipo_calculo" :rules="requeridoRegla" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Teléfono *" color="textbox"
                                    v-model="objFormBeneComp.telefono_pbx"
                                    v-mask="maskTelefono"
                                    :rules="_.concat(requeridoRegla,numeroRegla)"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-autocomplete label="Estado *" color="textbox" v-model="objFormBeneComp.id_estado"
                                    :items="listGeneralModal.listEstados" item-value="id_estado"
                                    item-text="nombre_estado" :rules="requeridoRegla" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="text-right">
                                <v-btn outlined rounded color="danger" class="mr-1" @click="cargaGeneral(false)" :disabled="disabled">Cancelar</v-btn>
                                <v-btn rounded dark color="primary" @click="insertarActualizar" :disabled="disabled">Guardar</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import { mask } from 'vue-the-mask';
    export default {
        props:['listGeneral'],
        directives:{mask},
        data: () =>({
            maskTelefono: "##########",
            listGeneralModal: [],
            objFormBeneComp:{},
            disabled: false
        }),
        methods:{
            cargaGeneral(opcion){
                if(opcion){//true: carga data
                    this.listGeneralModal = _.clone(this.listGeneral);
                    this.listGeneralModal.listTipoCalculo = _.filter(this.listGeneralModal.listTipoCalculo,(v) => { if(v.visualiza == 'true') return v; });
                    this.listGeneralModal.listEstados     = _.filter(this.listGeneralModal.listEstados,(v) => { if(v.visualiza == 'true') return v; });
                    this.objFormBeneComp = _.clone(this.$parent.$parent.objFormBeneComp);

                    if(_.size(this.objFormBeneComp.idBeneficio) > 0){
                        this.onListarSeguros('L')
                            .then((respuesta) => {
                                return this.onListarBeneficiosComplementarios('L');
                            })
                            .catch((e) => {
                                mensajesAlerta(e,'E');
                            });
                    }else{
                        this.listGeneralModal.listSeguro = [];
                        this.objFormBeneComp.id_tipo_calculo = this.listGeneralModal.listTipoCalculo[0].id_tipo_calculo;
                    }
                } else{ // reset data
                    this.$refs.form_beneficio_complementario.resetValidation();
                    this.$parent.$parent.objFormBeneComp = { titulo: 'Nuevo Beneficio Complementario', abrirModal: false, id_estado: _.toString(this.$parent.$parent.listParametros.idEstadoDefault) };
                    this.objFormBeneComp = { abrirModal: false};
                    this.listGeneralModal = [];
                }
            },
            insertarActualizar(){
                try {
                    if(!this.$refs.form_beneficio_complementario.validate()) throw mensajeEstandar.corregirInformacion;
                    this.$set(this.$parent.$parent,'objFormBeneComp',_.merge({},_.omit(this.objFormBeneComp,['titulo','abrirModal','beneficio','estado','idEstado']),
                                                                                {opcion: _.size(this.objFormBeneComp.idBeneficio) == 0 ? 'I' : 'U'},
                                                                                {id_beneficio_complementario: this.objFormBeneComp.idBeneficio}
                                                                            )
                                                                    );

                    var objeto = _.clone(this.$parent.$parent.objFormBeneComp);
                    this.$parent.$parent.objFormBeneComp = {};
                    _.forEach(_.keys(objeto), (v,k) => {
                                                            this.$set(this.$parent.$parent.objFormBeneComp,_.snakeCase(v),_.get(objeto,v));
                                                        });
                    this.$parent.$parent.insertarActualizar()
                                        .then((r) =>{
                                            if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                        })
                                        .catch((e) =>{
                                            this.disabled = false;
                                        })
                } catch (error) {
                    mensajesAlerta(error,'I');
                }
            },
            onListarSeguros(event,activar = false){
                if(!_.isUndefined(event)){
                    var objeto = {
                                    opcion: 'L_SEGURO_X_ASEGURADORA',
                                    idTipoPoliza: 10,
                                    idAseguradora: _.get(this.objFormBeneComp,'idAseguradora',null),
                                    idEstado     : _.get(this.objFormBeneComp,'idEstado',null) == 0 ? null : _.get(this.objFormBeneComp,'idEstado',null),
                                };

                    if(activar)
                        this.$set(this.objFormBeneComp,'idSeguro',null);

                    var p = this.$parent.$parent.ApiSend('administrador/poliza/listar',objeto)
                                                .then((r) => {
                                                    if(r.status != 200) throw mensajeEstandar.errorPeticion;
                                                    if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                                        if (_.size(_.get(r,['data','data'],[])) > 0) {
                                                            this.$set(this.listGeneralModal,'listSeguro',r.data.data);
                                                            
                                                            if(activar)
                                                                this.$set(this.objFormBeneComp,'idSeguro',this.listGeneralModal.listSeguro[0].idSeguro);
                                                        }
                                                        else
                                                            mensajesAlerta(r.data.mensaje,'I');
                                                    return r;
                                                });

                    if(activar){
                        p.catch((e) => { mensajesAlerta(e,'E'); });
                    }

                    return p;
                }
            },
            onListarBeneficiosComplementarios(event){
                if(!_.isUndefined(event)){
                    var objeto = {
                                    opcion: 'L_DETALLE',
                                    id_beneficio_complementario: _.get(this.objFormBeneComp,'idBeneficio',null),
                                    idEstado     : _.get(this.objFormBeneComp,'idEstado',null) == 0 ? null : _.get(this.objFormBeneComp,'idEstado',null),
                                };

                    var p = this.$parent.$parent.ApiSend('administrador/beneficioComplementario/listar',objeto)
                                                .then((respuesta) => {
                                                    if(respuesta.status != 200) throw mensajeEstandar.errorPeticion;
                                                    if(respuesta.data.existeError) throw mensajeEstandar.errorPeticion;
                                                    if(_.size(respuesta.data.data) > 0){
                                                        this.$set(this,'objFormBeneComp',_.merge({},this.objFormBeneComp,respuesta.data.data[0]));
                                                        var base64 = _.includes(this.objFormBeneComp.base64,'image/svg') ? 'data:image/svg+xml;base64,'+_.get(_.split(this.objFormBeneComp.base64,','),'1',null) : this.objFormBeneComp.base64;
                                                        var base64App = _.includes(this.objFormBeneComp.base64_pathApp,'image/svg') ? 'data:image/svg+xml;base64,'+_.get(_.split(this.objFormBeneComp.base64_pathApp,','),'1',null) : this.objFormBeneComp.base64_pathApp;
                                                        this.objFormBeneComp.logoWeb = base64;
                                                        this.objFormBeneComp.logoApp = base64App;
                                                        this.$delete(this.objFormBeneComp,'base64');
                                                        this.$delete(this.objFormBeneComp,'base64_pathApp');
                                                    }
                                                    else
                                                        mensajesAlerta(respuesta.data.mensaje,'I');
                                                    return respuesta;
                                                });                
                    return p;
                }
            },
            abrirVentana(event,icono){
                this.$refs[icono].click()
            },
            obtenerFile(e,atributo){
                var file = e.target.files;
                    try {
                        if(_.isUndefined(file[0])) throw mensajeEstandar.faltaArchivos;
                        if(file[0].name.lastIndexOf('.') <= 0) throw mensajeEstandar.archivo;
                        if((file[0].name.search('.svg') == -1) && (file[0].name.search('.png') == -1)) throw mensajeEstandar.archivo;
                            const fr = new FileReader ();
                            fr.readAsDataURL(file[0])
                            fr.addEventListener('load', () => {
                                this.$set(this.objFormBeneComp,atributo,fr.result);
                                this.$forceUpdate();
                            });
                    } catch (e) {
                        mensajesAlerta(e,'E');
                    }
            }
        }
    }
</script>
<style type="text/css">
    .image{
        width: auto !important;
        height: 50px !important;
    }
</style>